<template>
    <span>
        <el-button round type="danger" @click="getPaymentUrl(communityId)">
            Invoice Payment Link
        </el-button>

        <el-dialog
            :visible.sync="paymentUrlModalVisible"
            title="Payment URL"
            width="30%"
        >
            <p>
                Payment URL:
                <a :href="paymentUrl" target="_blank">{{ paymentUrl }}</a>
            </p>
            <p>
                <el-input
                    type="textarea"
                    :autosize="{ minRows: 3, maxRows: 6 }"
                    v-model="paymentUrl"
                    name="paymentUrl"
                /><a href="#" @click.prevent="copyPaymentUrl">
                    Copy <i class="mdi mdi-content-copy"></i
                ></a>
            </p>
            <p>
                <img :src="paymentUrlQrCode" alt="QR Code" />
            </p>
            <span slot="footer" class="dialog-footer">
                <el-button @click="paymentUrlModalVisible = false"
                    >OK</el-button
                >
            </span>
        </el-dialog>
    </span>
</template>

<script>
export default {
    props: {
        communityId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            paymentUrl: "",
            paymentUrlModalVisible: false,
            paymentUrlQrCode: ""
        };
    },
    methods: {
        async getPaymentUrl(communityId) {
            try {
                const response = await fetch(
                    `/web-api/community/${communityId}/payment-url`
                );
                const data = await response.json();
                const paymentUrl = data.payment_url;
                const paymentUrlQrCode = data.qr_code;

                // Show modal
                this.paymentUrl = paymentUrl;
                this.paymentUrlQrCode = paymentUrlQrCode;
                this.paymentUrlModalVisible = true;
            } catch (error) {
                console.error("Error copying payment URL:", error);
            }
        },
        copyPaymentUrl() {
            // Copy to clipboard
            const el = document.createElement("textarea");
            el.value = this.paymentUrl;
            document.body.appendChild(el);
            el.select();
            document.execCommand("copy");
            document.body.removeChild(el);
            alert("Payment URL has been copied to your clipboard.");
        }
    }
};
</script>

<style scoped>
/* Add any styles specific to this component here */
</style>
